export interface UserDateRange {
  from: string;
  to: string;
}

export interface UserNumberRange {
  min: number | null;
  max: number | null;
}

export interface UserFilters {
  name: string;
  email: string;
  role: string;
  status: string;
  age: number | null;
  date_of_birth: Date | null;
  join_date: UserDateRange;
  last_active_at: UserDateRange;
  available_points: UserNumberRange;
}

export const defaultUserFilters: UserFilters = {
  name: "",
  email: "",
  role: "",
  status: "",
  age: null,
  date_of_birth: null,
  join_date: { from: "", to: "" },
  last_active_at: { from: "", to: "" },
  available_points: { min: null, max: null },
};

export interface UserItem {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  age: number | null;
  date_of_birth: string | null;
  status: string;
  country_code: string;
  country?: string;
  zip_code?: string;
  gender?: "male" | "female" | "other";
  language?: "english" | "vietnamese";
  population_id?: string | null;
  phone_number: string;
  profile_image_url: string;
  role: string;
  is_email_verified: boolean;
  last_login_date: string | null;
  last_active_at: string | null;
  current_point: number;
  created_at: string;
  updated_at: string;
}

export interface UserListRequest {
  index: number;
  size: number;
  name?: string;
  email?: string;
  role?: string;
  status?: string;
  age?: number;
  date_of_birth?: string;
  join_date_from?: string;
  join_date_to?: string;
  sort_key?: string;
  sort_direction?: "asc" | "desc";
}

export interface UserListForAdminResponse {
  paging: { count: number; index: number; size: number };
  list: UserItem[];
}

export interface UserStatistics {
  total_users: number;
  new_users: number;
  active_users: number;
  inactive_users: number;
  engaged_users: number;
}

export interface UserCreateRequest {
  first_name?: string;
  last_name?: string;
  email: string;
  country_code?: string;
  phone_number: string;
  country?: string;
  zip_code?: string;
  gender?: "male" | "female" | "other";
  date_of_birth?: string;
  language?: "english" | "vietnamese";
  population_id?: string;
  age?: number;
  password: string;
}

export interface UserImportResponse {
  usersCreated: number;
}

export interface UserImportValidationError {
  code: string;
  sheet?: string;
  row?: number;
  field?: string;
  message: string;
}

export interface UserImportItem {
  row_number: number;
  first_name?: string;
  last_name?: string;
  email: string;
  country_code?: string;
  phone_number: string;
  country?: string;
  zip_code?: string;
  gender?: string;
  date_of_birth?: string;
  language?: string;
  population_id?: string;
  password: string;
}

export interface UserImportReviewRow extends UserImportItem {
  errors: string[];
}

export interface UserImportValidationResponse {
  users: Array<{ row_number: number; status: "valid" | "invalid"; errors: UserImportValidationError[] }>;
}

export interface UserUpdateRequest {
  first_name?: string;
  last_name?: string;
  country_code?: string;
  country?: string;
  zip_code?: string;
  gender?: "male" | "female" | "other";
  date_of_birth?: string;
  language?: "english" | "vietnamese";
  phone_number?: string;
  population_id?: string;
  age?: number;
}
